import { render, staticRenderFns } from "./InviteSuccess.vue?vue&type=template&id=51c0bee6&scoped=true"
import script from "./InviteSuccess.vue?vue&type=script&lang=ts"
export * from "./InviteSuccess.vue?vue&type=script&lang=ts"
import style0 from "./InviteSuccess.vue?vue&type=style&index=0&id=51c0bee6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c0bee6",
  null
  
)

export default component.exports